module.exports = __webpack_public_path__ + "img/thermalpaperWidth.11955b71.png";